import { css } from 'goober';
import React, { useCallback, useEffect, } from 'react';
import sendFeedbackIcon from '../../assets/send_feedback_icon.svg';
import wallpaperIcon from '../../assets/set_wallpaper.svg';
import shareIcon from '../../assets/share.svg';
import State from '../../state';
import colors from '../../styles/colors';
import font from '../../styles/font';
import { transparentize } from '../../styles/mixins';
import { getFooterHeight } from '../../utils/glanceandroidbridge';
import { hasKhazaddumBridge, onShare, sendFeedback, setWallpaper, } from '../../utils/khazaddumbridge';
const Box = css `
  position: fixed;
  background: ${transparentize(0.3, colors.black)};
  top: 0;
  bottom: 0;
  width: 100%;
`;
const Tray = css `
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background: ${colors.codGray};
  position: absolute;
  bottom: ${getFooterHeight()};
  height: 144px;
  width: 100%;
  padding: 24px 24px 60px;
  color: ${colors.white};
  font-size: ${font.fontSmall};
  letter-spacing: -0.03px;
`;
const IconContainer = css `
  background-position: left;
  background-repeat: no-repeat;
  padding-left: 32px;
  margin-bottom: 24px;
  &:last-child {
    margin-bottom: 0;
  }
`;
const ShareIcon = css `
  background-image: url('${shareIcon}');
`;
const WallpaperIcon = css `
  background-image: url('${wallpaperIcon}');
`;
const FeedbackIcon = css `
  background-image: url('${sendFeedbackIcon}');
`;
const onCloseCb = 'window.menuCloseCb';
const ShareTray = ({ glanceId, shareUrl, attribution, closeDrawerMenu, bubbleEvent, }) => {
    useEffect(() => {
        var _a;
        if (hasKhazaddumBridge()) {
            window.menuCloseCb = () => {
                var _a;
                closeDrawerMenu();
                State.isShareTrayOpen = false;
                (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.unRegisterBackButtonListener();
            };
            (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.registerBackButtonListener(onCloseCb);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        State.isShareTrayOpen = true;
        return () => {
            State.isShareTrayOpen = false;
        };
    }, []);
    const closeDrawer = useCallback((e) => {
        var _a;
        if (e.target === e.currentTarget) {
            closeDrawerMenu();
            State.isShareTrayOpen = false;
            if (hasKhazaddumBridge()) {
                (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.unRegisterBackButtonListener();
            }
        }
    }, [closeDrawerMenu]);
    const shareContent = useCallback(() => {
        onShare(glanceId, shareUrl, null, onCloseCb);
        bubbleEvent.setGlanceShared(glanceId, 'generic');
    }, [glanceId, shareUrl, bubbleEvent]);
    const sendProductFeedback = useCallback(() => {
        sendFeedback(glanceId, onCloseCb);
    }, [glanceId]);
    const setAsWallpaper = useCallback(() => {
        var _a;
        setWallpaper(glanceId, attribution, onCloseCb);
        if (hasKhazaddumBridge()) {
            (_a = window.KhazadDumBridge) === null || _a === void 0 ? void 0 : _a.unRegisterBackButtonListener();
        }
        else {
            closeDrawerMenu();
        }
    }, [glanceId, attribution, closeDrawerMenu]);
    return (React.createElement("div", { onClick: closeDrawer, className: Box },
        React.createElement("div", { className: Tray },
            React.createElement("div", { className: `${IconContainer} ${ShareIcon}`, onClick: shareContent }, "Share"),
            React.createElement("div", { className: `${IconContainer} ${WallpaperIcon}`, onClick: setAsWallpaper }, "Set as homescreen wallpaper"),
            React.createElement("div", { className: `${IconContainer} ${FeedbackIcon}`, onClick: sendProductFeedback }, "Send Feedback"))));
};
export default ShareTray;
//# sourceMappingURL=index.js.map